import React from "react"
import { NavLink } from "react-router-dom"
import Header4 from "./../Common/Header4"
import Footer from "./../Common/Footer"
import Banner from "./../Elements/Banner"

const filters = [
  { label: "Residential", filter: ".col-one" },
  { label: "Commercial", filter: ".col-two" },
  { label: "Mixed-used Development", filter: ".col-three" },
]

const projects = [
  {
    image: require("./../../images/grand/1.png"),
    title: "The Grand Hayah Hotel",
    href: "Grand",
    address: "Redsea, Saudi Arabia",
    filter: "col-two",
  },
  {
    image: require("./../../images/lotus/5.png"),
    title: "Lotus",
    href: "Lotus",
    address: "New cairo- Egypt",
    filter: "col-one",
  },
  {
    image: require("./../../images/four/1.png"),
    title: "Four season Jeddah hotel",
    href: "four",
    address: "Jeddah, Saudia Arabia",
    filter: "col-three",
  },
  {
    image: require("./../../images/Marseilia/26.png"),
    title: "Marseilia Villa",
    href: "Marseilia",
    address: "North Coast",
    filter: "col-one",
  },
  {
    image: require("./../../images/Marseilia/27.png"),
    title: "Banafseg Duplex",
    href: "Banafseg",
    address: "Banafseg, New Cairo",
    filter: "col-one",
  },
  {
    image: require("./../../images/Marseilia/28.png"),
    title: "Icity Apartment",
    href: "Icity",
    address: "Mountain view, New Cairo",
    filter: "col-one",
  },
  {
    image: require("./../../images/Marseilia/29.png"),
    title: "Ivilla",
    href: "Ivilla",
    address: "Mountain view, New Cairo",
    filter: "col-one",
  },
  {
    image: require("./../../images/Marseilia/30.png"),
    title: "Villa Marassi",
    href: "Marassi",
    address: "Marassi, North Coast",
    filter: "col-one",
  },
  {
    image: require("./../../images/Marseilia/31.png"),
    title: "Apartment Palm Hills",
    href: "Palm",
    address: "Palm Hills, Cairo",
    filter: "col-one",
  },
  {
    image: require("./../../images/Marseilia/32.png"),
    title: "Villa Contemporary Luxury KSA",
    href: "Jeddah1",
    address: "Jeddah, KSA",
    filter: "col-one",
  },
  {
    image: require("./../../images/Marseilia/33.png"),
    title: "Villa Modern Luxury KSA",
    href: "Jeddah2",
    address: "Jeddah, KSA",
    filter: "col-one",
  },
]

var bnrimg = require("./../../images/banner/6.jpg")
var bgimg1 = require("./../../images/background/cross-line.png")

class ProjectGrid4 extends React.Component {
  componentDidMount() {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script")
        script.src = src
        script.addEventListener("load", function () {
          resolve()
        })
        script.addEventListener("error", function (e) {
          reject(e)
        })
        document.body.appendChild(script)
        document.body.removeChild(script)
      })
    }

    loadScript("./assets/js/custom.js")
  }
  render() {
    return (
      <>
        <Header4 />
        <div className="page-content">
          <Banner
            title="PROJECTS"
            pagename="Projects"
            // description="The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized."
            bgimage={bnrimg}
          />

          {/* SECTION CONTENT START */}
          <div className="section-full p-tb80 column-grid-4 inner-page-padding">
            <div className="container">
              {/* Filter Nav START */}
              <div className="filter-wrap p-b30 text-center">
                <ul className="filter-navigation masonry-filter clearfix">
                  <li className="active">
                    <NavLink
                      to={"#"}
                      className="btn from-top"
                      data-filter="*"
                      data-hover="All"
                    >
                      All
                    </NavLink>
                  </li>
                  {filters.map((item, index) => (
                    <li key={index}>
                      <NavLink
                        to={"#"}
                        className="btn from-top"
                        data-filter={item.filter}
                      >
                        {item.label}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
              {/* Filter Nav END */}
              {/* GALLERY CONTENT START */}
              <ul className="masonry-outer mfp-gallery row work-grid clearfix list-unstyled">
                {projects.map((item, index) => (
                  <div
                    key={index}
                    className={`${item.filter} masonry-item col-xl-3  col-lg-4 col-md-6 col-sm-12 m-b30`}
                  >
                    <a href={`/${item.href}`}>
                      <div className="sx-box image-hover-block">
                        <div className="sx-thum-bx">
                          <img src={item.image} alt="" />
                        </div>
                        <div className="sx-info  p-t20 text-white">
                          <h4 className="sx-tilte">
                            <NavLink to={`/${item.href}`}>{item.title}</NavLink>
                          </h4>
                          <p className="m-b0">{item.address}</p>
                        </div>
                        <a className="mfp-link" href={item.image}>
                          <i className="fa fa-arrows-alt" />
                        </a>
                      </div>
                    </a>
                  </div>
                ))}
              </ul>
              {/* GALLERY CONTENT END */}
              {/* <div
                className="text-center load-more-btn-outer"
                style={{ backgroundImage: "url(" + bgimg1 + ")" }}
              >
                <button className="site-button-secondry btn-half">
                  <span>Load More</span>
                </button>
              </div> */}
            </div>
          </div>
          {/* SECTION CONTENT END  */}
        </div>

        <Footer />
      </>
    )
  }
}

export default ProjectGrid4
